<template>
    <Form
        :data="data"
        :readonly="readonly"
    />
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    props: {
        data: { type: Object, required: true },
        readonly: { type: Boolean, default: true },
    },
}
</script>